import { $$ } from './helper'

export class Tracking {
  constructor (settings = {}) {
    this.options = $.extend({
      googleAnalyticsId: 'UA-39332172-1',
      googleAdsId: 'AW-806733915',
      googleTagManager: 'GTM-P9C5JHZ',
      allowedDomains: [
        'www.bkkgs.de',
        'www-dev.bkkgs.de'
      ]
    },
    settings)
  }

  init () {
    const that = this

    this.options.allowedDomains.forEach(function (domain) {
      if (domain === window.location.hostname) {
        if ((window.name === 'newTYPO3frontendWindow') || (Cookiebot.consent !== undefined && Cookiebot.consent.statistics)) {
          that.addGoogleTagManager()
        }

        // add matomo without cookies
        that.addMatomoTagManager()
        that.addMatomo()
      }
    })
  }

  addGoogleTagManager () {
    const googleTagManagerScript = $$('#googleTagManager')
    if (googleTagManagerScript.length === 0) {
      const script = document.createElement('script')

      script.src = 'https://www.googletagmanager.com/gtm.js?id=' + this.options.googleTagManager
      script.type = 'text/javascript'
      script.id = 'googleTagManager'
      script.async = true
      document.head.appendChild(script)
      window.dataLayer = window.dataLayer || []

      this.gtag('gtm.start', new Date().getTime())
      this.gtag('event', 'gtm.js')
    }
  }

  addMatomo () {
    const matomo = $$('#matomo')
    if (matomo.length === 0) {
      const _paq = window._paq = window._paq || []
      _paq.push(['trackPageView'])
      _paq.push(['enableLinkTracking'])

      const u = '//www.bkkgs.de/matomo/'

      _paq.push(['setTrackerUrl', u + 'matomo.php'])
      _paq.push(['setSiteId', '1'])

      const d = document
      const g = d.createElement('script')
      const s = d.getElementsByTagName('script')[0]
      g.async = true
      g.src = u + 'matomo.js'
      g.id = 'matomo'
      s.parentNode.insertBefore(g, s)
    }
  }

  addMatomoTagManager () {
    const matomotag = $$('#matomotag')
    if (matomotag.length === 0) {
      const _mtm = window._mtm = window._mtm || []
      const d = document
      const g = d.createElement('script')
      const s = d.getElementsByTagName('script')[0]

      _mtm.push({
        'mtm.startTime': (new Date().getTime()),
        event: 'mtm.Start'
      })

      g.async = true
      g.src = 'https://www.bkkgs.de/matomo/js/container_3EBPR2dT.js'
      g.id = 'matomotag'
      s.parentNode.insertBefore(g, s)
    }
  }

  gtag () {
    window.dataLayer.push(arguments)
  }
}

export default Tracking
